// removed by extract-text-webpack-plugin
module.exports = {"section":"batch-edit-form__section___1rYVg","fields-container":"batch-edit-form__fields-container___11lUm","fields-container__row":"batch-edit-form__fields-container__row___38yry","actions":"batch-edit-form__actions___w2SaQ"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/batch-edit-form.scss
// module id = 1317
// module chunks = 0